(function () {
  const zone = document.getElementById('tweentees-snow');
  if (!zone) return;

  // Avoid double-init in Theme Editor hot reload
  if (zone.dataset.inited) return;
  zone.dataset.inited = '1';

  const MAX_FLAKES = 60;
  const HEADER_HEIGHT = 140; // match CSS height

  function makeFlake() {
    const f = document.createElement('i');
    f.className = 'tweentees-flake';
    const size = Math.random() * 5 + 3; // 3–8px
    const dur = Math.random() * 5 + 6;  // 6–11s
    const delay = Math.random() * 3;    // 0–3s
    const drift = (Math.random() - 0.5) * 80; // -40 to 40px

    f.style.left = Math.random() * window.innerWidth + 'px';
    f.style.setProperty('--size', size + 'px');
    f.style.setProperty('--dur', dur + 's');
    f.style.setProperty('--delay', delay + 's');
    f.style.setProperty('--drift', drift + 'px');

    zone.appendChild(f);

    // Clean up after it falls past header
    setTimeout(() => {
      f.remove();
    }, (dur + delay) * 1000);
  }

  // Seed some flakes
  for (let i = 0; i < MAX_FLAKES / 2; i++) makeFlake();

  // Keep it gentle: add a few every 300ms
  const timer = setInterval(() => {
    if (!document.body.contains(zone)) { clearInterval(timer); return; }
    if (zone.childElementCount < MAX_FLAKES) makeFlake();
  }, 300);

  // Resize safety
  window.addEventListener('resize', () => {
    zone.style.height = HEADER_HEIGHT + 'px';
  });
})();
